module.exports = __webpack_public_path__ + "static/media/pencil-hover.bf9fdc7b.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/icons/pencil-hover.svg
 ** module id = 459
 ** module chunks = 0
 **/